import { Component, inject } from '@angular/core';

import { FilteringService } from '../../services/filtering';
import { ModelCard } from '../model-card/model-card';

@Component({
  imports: [ModelCard],
  selector: 'app-suggested-models',
  styleUrl: './suggested-models.css',
  templateUrl: './suggested-models.html',
})
export class SuggestedModels {
  protected readonly filteringService = inject(FilteringService);

  public setModelFilter(model: string): void {
    void this.filteringService.resetFilters();
    this.filteringService.models.set([model.split('-')[0]]); // The model filter is in the format "modelId-modelName", so we split on the hyphen and take the first part as the model ID.
  }
}
